module.exports = __webpack_public_path__ + "static/media/video.cb4dcf73.mp4";